export default __webpack_public_path__ + "static/batch-tx-2f0a84e48984afd1ef97d1bbf23aafe6.jpg";